// FETCH ALL YARN_MASTER
export const FETCH_YARN_MASTER_REQUEST = 'FETCH_YARN_MASTER_REQUEST';
export const FETCH_YARN_MASTER_SUCCESS = 'FETCH_YARN_MASTER_SUCCESS';
export const FETCH_YARN_MASTER_FAILURE = 'FETCH_YARN_MASTER_FAILURE';

export const FETCH_YARN_MATERIALS_REQUEST = 'FETCH_YARN_MATERIALS_REQUEST';
export const FETCH_YARN_MATERIALS_SUCCESS = 'FETCH_YARN_MATERIALS_SUCCESS';
export const FETCH_YARN_MATERIALS_FAILURE = 'FETCH_YARN_MATERIALS_FAILURE';

// FETCH ALL YARN_MASTER
export const FETCH_YARN_MASTER_GROUP_DISTINCT_REQUEST = 'FETCH_YARN_MASTER_GROUP_DISTINCT_REQUEST';
export const FETCH_YARN_MASTER_GROUP_DISTINCT_SUCCESS = 'FETCH_YARN_MASTER_GROUP_DISTINCT_SUCCESS';
export const FETCH_YARN_MASTER_GROUP_DISTINCT_FAILURE = 'FETCH_YARN_MASTER_GROUP_DISTINCT_FAILURE';

// FETCH ALL YARN_MASTER
export const FETCH_YARN_MASTER_TYPE_DISTINCT_REQUEST = 'FETCH_YARN_MASTER_TYPE_DISTINCT_REQUEST';
export const FETCH_YARN_MASTER_TYPE_DISTINCT_SUCCESS = 'FETCH_YARN_MASTER_TYPE_DISTINCT_SUCCESS';
export const FETCH_YARN_MASTER_TYPE_DISTINCT_FAILURE = 'FETCH_YARN_MASTER_TYPE_DISTINCT_FAILURE';

// CREATE YARN_MASTER
export const CREATE_YARN_MASTER_REQUEST = 'CREATE_YARN_MASTER_REQUEST';
export const CREATE_YARN_MASTER_SUCCESS = 'CREATE_YARN_MASTER_SUCCESS';
export const CREATE_YARN_MASTER_FAILURE = 'CREATE_YARN_MASTER_FAILURE';

// FETCH SINGLE PART DATA
export const FETCH_SINGLE_YARN_MASTER_REQUEST = 'FETCH_SINGLE_YARN_MASTER_REQUEST';
export const FETCH_SINGLE_YARN_MASTER_SUCCESS = 'FETCH_SINGLE_YARN_MASTER_SUCCESS';
export const FETCH_SINGLE_YARN_MASTER_FAILURE = 'FETCH_SINGLE_YARN_MASTER_FAILURE';

// UPDATE YARN_MASTER
export const UPDATE_YARN_MASTER_REQUEST = 'UPDATE_YARN_MASTER_REQUEST';
export const UPDATE_YARN_MASTER_SUCCESS = 'UPDATE_YARN_MASTER_SUCCESS';
export const UPDATE_YARN_MASTER_FAILURE = 'UPDATE_YARN_MASTER_FAILURE';

// DELETE YARN_MASTER
export const DELETE_YARN_MASTER_REQUEST = 'DELETE_YARN_MASTER_REQUEST';
export const DELETE_YARN_MASTER_SUCCESS = 'DELETE_YARN_MASTER_SUCCESS';
export const DELETE_YARN_MASTER_FAILURE = 'DELETE_YARN_MASTER_FAILURE';

export const RESET_YARN_MASTER_INFO = 'RESET_YARN_MASTER_INFO';

export const CREATE_YARN_MASTER_FORM = 'CREATE_YARN_MASTER_FORM';

export const UPDATE_YARN_MASTER_FORM = 'UPDATE_YARN_MASTER_FORM';
